/**
 * @generated SignedSource<<14635f329fc9fd4603a355ca0e5146e7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MediaEditorSort_media$data = {
  readonly __id: string;
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly id: string;
    };
  }>;
  readonly " $fragmentType": "MediaEditorSort_media";
};
export type MediaEditorSort_media$key = {
  readonly " $data"?: MediaEditorSort_media$data;
  readonly " $fragmentSpreads": FragmentRefs<"MediaEditorSort_media">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MediaEditorSort_media",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MediaEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Media",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__id",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "MediaConnection",
  "abstractKey": null
};

(node as any).hash = "a6a7e3ca960b45edac4c2c1991508a2a";

export default node;
